module.exports = __webpack_public_path__ + "static/img/heroimage_setting_large.dce078a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_setting_large.png
// module id = 367
// module chunks = 1